import React from "react";
import { motion } from "framer-motion";
import { HiChevronDown } from "react-icons/hi";
import { Link } from "react-scroll";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative h-screen flex flex-col justify-center items-center text-center overflow-hidden"
    >
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="/assets/main.jpg"
      >
        <source src="/assets/merged_food_video.webm" type="video/webm" />
        <source src="/assets/merged.mov" type="video/quicktime" />
      </video>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

      {/* Content */}
      <div className="relative z-10 px-6 max-w-4xl mx-auto">
        <motion.img
          src="/assets/PHBLogo.png"
          alt="The Pahadi Bistro logo"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="h-20 w-20 md:h-24 md:w-24 object-contain mx-auto mb-5 drop-shadow-lg"
        />

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-gold font-semibold tracking-[0.25em] uppercase text-sm md:text-base mb-4"
        >
          Kharadi, Pune
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="text-4xl sm:text-5xl md:text-7xl font-display font-bold text-white leading-tight text-balance"
          style={{
            textShadow:
              "0 0 20px rgba(0,0,0,0.8), 0 0 40px rgba(234, 193, 44, 0.86), 0 4px 12px rgba(11, 11, 11, 0)",
          }}
        >
          Authentic Nepali &amp; Indo-Chinese Flavours
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="mt-5 text-cream/90 text-lg md:text-xl font-medium max-w-2xl mx-auto"
        >
          A delicious journey from the pahad to your plate. Handcrafted momos,
          bold noodles, and pahadi-style comfort food.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1.0 }}
          className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link
            to="menu"
            smooth
            duration={600}
            offset={-70}
            className="inline-block px-8 py-3.5 bg-redAccent text-white font-semibold rounded-full hover:bg-redDark transition-all duration-200 cursor-pointer shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          >
            Explore Our Menu
          </Link>
          <Link
            to="about"
            smooth
            duration={600}
            offset={-70}
            className="inline-block px-8 py-3.5 border-2 border-white/40 text-white font-semibold rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer"
          >
            Our Story
          </Link>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 0.8 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <Link
          to="about"
          smooth
          duration={600}
          className="cursor-pointer flex flex-col items-center text-white/60 hover:text-white/90 transition-colors"
          aria-label="Scroll to next section"
        >
          <span className="text-xs tracking-widest uppercase mb-2">Scroll</span>
          <HiChevronDown className="w-6 h-6 animate-bounce-slow" />
        </Link>
      </motion.div>
    </section>
  );
}
